/* 
 * This is user selection combobox with remote lookup
 */

/* global customElements */
import '@vaadin/combo-box';
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

class UserSelect extends customElements.get('vaadin-combo-box') {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();	
				
		var userSelect = this;
		setTimeout(function(){
			userSelect.init();
		});
	}
	
	init() {
		var userSelect = this;
		userSelect.itemIdPath = 'userId';
		userSelect.itemValuePath = 'userId';
		
		userSelect.dataProvider = function(params, callback) {
			
			var index = params.page * params.pageSize;
			var filter = {
				offset: index,
				max: params.pageSize,
				filterField: 'firstname',
				filterValue: params.filter,
				sortField: 'firstname'
			};
			
			Service.getUserService().getUsers(filter).then(function(users){		
				var justUserInfo = [];
				
				users.data.forEach(function(user){
					justUserInfo.push({
						label: user.userProfile.firstname + ' ' + user.userProfile.lastname + ' (' + user.userProfile.userId + ')',
						userId: user.userProfile.userId
					});
				});				
				
				setTimeout(function() {
					callback(justUserInfo, users.totalNumber);
				}, 2000);
			});
		};
		
	}
	
};
customElements.define('dl-user-select', UserSelect);
	

